import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/map'
import {Observable} from 'rxjs/Observable';
import {AuthService} from './auth.service';
import {User} from 'storyboard-renderer';
import {environment} from '../../environments/environment';


@Injectable()
export class UserService {
  constructor(
      private http: Http,
      private authenticationService: AuthService) {
  }

  getUsers(): Observable<User[]> {
    // add authorization header with jwt token
    const headers = new Headers({ 'Authorization': 'Bearer ' + this.authenticationService.token });
    const options = new RequestOptions({ headers: headers });

    // get users from api
    return this.http.get(environment.apiBaseUrl + '/api/v1.0/user', options)
        .map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/user.service.ts